import { fetchCompanyEdit, fetchBranchData } from '../../../apiService';

// Company configuration for invoice PDF
// This can be moved to a separate configuration file or database

export const getCompanyConfig = () => {
  return {
    name: 'Your Company Name',
    address: 'Company Address Line 1',
    addressLine2: 'Company Address Line 2',
    city: 'City Name',
    state: 'State Name',
    pincode: '000000',
    phone: '+91 00000 00000',
    email: 'ashwin.antony@efftabs.com',
    website: 'www.company.com',
    gst: 'GST Number',
    pan: 'PAN Number',
    
    // Bank Details
    bankName: 'Your Bank Name',
    accountNo: 'XXXX XXXX XXXX',
    ifscCode: 'XXXX0000XXX',
    branch: 'Branch Name',
    
    // Support
    support: 'support@company.com',
    
    // Logo (optional - can be a URL or base64)
    logo: null,
    
    // Invoice Settings
    invoiceSettings: {
      showLogo: true,
      showBankDetails: true,
      showTermsAndConditions: true,
      showSignature: true,
      currency: 'INR',
      currencySymbol: '₹',
      
      // Terms and Conditions
      termsAndConditions: [
        'Payment is due within 30 days of invoice date.',
        'Late payments may incur additional charges.',
        'Goods once sold will not be taken back.',
        'Subject to local jurisdiction only.'
      ],
      
      // Footer text
      footerText: 'Thank you for your business!',
      
      // Colors (hex codes)
      primaryColor: '#1e40af',
      secondaryColor: '#dc2626',
      accentColor: '#059669'
    }
  };
};

// Fetch company details from API using separate Company Edit and Branch Data APIs
export const getCompanyConfigFromAPI = async (companyId, branchId, token) => {
  try {
    console.log('getCompanyConfigFromAPI called with:', { companyId, branchId, token: token ? 'present' : 'missing' });
    
    // Make separate API calls for Company Edit and Branch Data
    console.log('Making API calls...');
    const [companyResponse, branchResponse] = await Promise.all([
      fetchCompanyEdit(companyId, token),
      fetchBranchData(companyId, branchId, token)
    ]);
    
    console.log('API responses received:', { companyResponse, branchResponse });

    // Extract actual data from API response structure
    // API returns: { response_data: [actualData] }
    const companyData = companyResponse?.response_data?.[0] || companyResponse;
    const branchData = branchResponse?.response_data || branchResponse;
    
    console.log('Extracted data:', { companyData, branchData });
    
    // Map API responses to expected format
    const mappedConfig = {
      // Company name from Company Edit API
      name: companyData?.Name || companyData?.name || companyData?.CompanyName || 'Your Company Name',
      
      // Branch details from Branch Data API (fallback to company data if branch data not available)
      address: branchData?.AddressLine1  || '',
      addressLine2: branchData?.AddressLine2  || '',
      city: '',
      state: branchData?.Location || '',
      pincode: branchData?.PinCode || '',
      phone: branchData?.ContactNumber1 || '',
      email: branchData?.Email  || '',
      website: '',
      gst: branchData?.GSTNumber || '',
      pan: branchData?.PanNumber || '',
      
      // Bank Details from Branch Data (fallback to company data)
      bankName: branchData?.BankName || '',
      accountNo: branchData?.AccountNumber || '',
      ifscCode: branchData?.IFSCCode || '',
      branch: branchData?.BranchName || '',
      
      // Support
      support: branchData?.SupportEmail || branchData?.support || branchData?.supportEmail || companyData?.SupportEmail || 'support@company.com',
      
      // Logo (optional - can be a URL or base64)
      logo: companyData?.Logo || branchData?.Logo || companyData?.logo || branchData?.logo || null,
      
      // Invoice Settings (keep defaults but allow override from branch data)
      invoiceSettings: {
        showLogo: branchData?.ShowLogo ?? branchData?.showLogo ?? true,
        showBankDetails: branchData?.ShowBankDetails ?? branchData?.showBankDetails ?? true,
        showTermsAndConditions: branchData?.ShowTermsAndConditions ?? branchData?.showTermsAndConditions ?? true,
        showSignature: branchData?.ShowSignature ?? branchData?.showSignature ?? true,
        currency: branchData?.Currency || branchData?.currency || 'INR',
        currencySymbol: branchData?.CurrencySymbol || branchData?.currencySymbol || '₹',
        
        // Terms and Conditions
        termsAndConditions: branchData?.TermsAndConditions || branchData?.termsAndConditions || [
          'Payment is due within 30 days of invoice date.',
          'Late payments may incur additional charges.',
          'Goods once sold will not be taken back.',
          'Subject to local jurisdiction only.'
        ],
        
        // Footer text
        footerText: branchData?.FooterText || branchData?.footerText || 'Thank you for your business!',
        
        // Colors (hex codes)
        primaryColor: branchData?.PrimaryColor || branchData?.primaryColor || '#1e40af',
        secondaryColor: branchData?.SecondaryColor || branchData?.secondaryColor || '#dc2626',
        accentColor: branchData?.AccentColor || branchData?.accentColor || '#059669'
      }
    };
    
    console.log('Mapped config:', mappedConfig);
    return mappedConfig;
  } catch (error) {
    console.error('Error fetching company details from API:', error);
    console.error('Error details:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    // Return default config if API fails
    return getCompanyConfig();
  }
};

// Function to update company config (can be connected to API later)
export const updateCompanyConfig = (newConfig) => {
  // This would typically save to database or local storage
  console.log('Company config updated:', newConfig);
  return newConfig;
};